import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class CorrosionShields extends Component {
  render() {
    return (
      <EntityList apiRoute='api/corrosionshields' title='Remorque - Barrières anticorrosion' editTitle='Barrière anticorrosion' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default CorrosionShields;



/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/corrosionShields.js
 **/